import React from 'react';

import {
  Download as DownloadIcon,
  DownloadDone as DownloadDoneIcon,
  Error as ErrorIcon
} from '@mui/icons-material';
import {
  CircularProgress,
  IconButton
} from '@mui/material';
import {
  appEvents,
  authService,
  baseTypes,
  downloadUtil,
  protectedFileUtil
} from 'modules';

import * as dataService from './dataService';



type IStatus = 'notDownloaded' | 'downloading' | 'downloadSuccess' | 'error';

interface IProps {
  apiFileData: baseTypes.IApiFileData;
  color?: string;
  showSnackbarHint?: boolean;
}

export const FC: React.FC<IProps> = props => {
  const fnRunQuery = dataService.useQuery();

  const [downloadingStatus, setDownloadingStatus] = React.useState<IStatus>('notDownloaded');



  async function handleClickDownload() {
    const authState = await authService.getAuthState();

    if (authState.accessToken) {
      setDownloadingStatus('downloading');

      try {
        const blob = await protectedFileUtil.fetchFile(authState.accessToken, props.apiFileData.key);

        downloadUtil.downloadBlob(blob, props.apiFileData.fileName);
        setDownloadingStatus('downloadSuccess');

        if (props.showSnackbarHint) {
          const results = await fnRunQuery();
          if (!results.allAccessEnabled) {
            appEvents.broadcast({
              type: 'snackbar',
              args: {
                type: 'downloadLimit',
                subscriptionStatus: results.subscriptionStatus,
                currentDownloads: results.totalUsage,
                totalDownloads: results.totalAllowed
              }
            });
          }
        }

      } catch (error) {
        setDownloadingStatus('error');

        if (error instanceof Error) {
          if (error.message === 'Download Limit Exceeded' && props.showSnackbarHint) {
            appEvents.broadcast({
              type: 'snackbar',
              args: {
                type: 'downloadLimitReached'
              }
            });
          }
        }
      }
    }
  }



  if (downloadingStatus === 'notDownloaded') {
    return (
      <IconButton onClick={handleClickDownload}>
        <DownloadIcon style={{ color: props.color ?? '#87ACB9' }} />
      </IconButton>
    );

  } else if (downloadingStatus === 'downloading') {
    return (
      <CircularProgress style={{ fontSize: 24, padding: 8 }} />
    );

  } else if (downloadingStatus === 'error') {
    return (
      <IconButton disabled>
        <ErrorIcon color="error" />
      </IconButton>
    );

  } else if (downloadingStatus === 'downloadSuccess') {
    return (
      <IconButton disabled>
        <DownloadDoneIcon color="success" />
      </IconButton>
    );

  }

  return null;
};
